import React from "react";
import SchedulePage from "@iventis/schedule/src/schedule";
import PageWithAppBar from "./page-with-appbar";

export default () => (
    <PageWithAppBar>
        <SchedulePage />
    </PageWithAppBar>
);
